"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var compose = require('../../hoc/compose');

var displayNames = require('../../controls/displayNames');

var PanelFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(PanelFooter, _React$Component);

  var _super = _createSuper(PanelFooter);

  function PanelFooter() {
    _classCallCheck(this, PanelFooter);

    return _super.apply(this, arguments);
  }

  _createClass(PanelFooter, [{
    key: "render",
    value: function render() {
      var ActionBtnSymbol = this.props.actionBtnSymbol;
      var Thumbnails = this.props.thumbnails;
      return /*#__PURE__*/React.createElement("footer", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.props.getClassName('panel-footer'),
        style: this.props.style
      }, ActionBtnSymbol ? /*#__PURE__*/React.createElement(ActionBtnSymbol, null) : null, /*#__PURE__*/React.createElement("div", {
        className: "panel-footer-action-btn"
      }, this.props.actionBtn), Thumbnails ? /*#__PURE__*/React.createElement(Thumbnails, null) : null);
    }
  }]);

  return PanelFooter;
}(React.Component);

PanelFooter.displayName = displayNames.PANEL_FOOTER;
PanelFooter.propTypes = {
  actionBtn: PropTypes.element,
  onActionBtn: PropTypes.func,
  noActionBtn: PropTypes.bool,
  actionButtonSymbol: PropTypes.element,
  thumbnails: PropTypes.element
};
PanelFooter.defaultProps = {
  dataHook: 'panel-footer'
};
module.exports = compose(PanelFooter);